(function () {
    if (window.__bfRevealLoaded) return;
    window.__bfRevealLoaded = true;

    function initBaseformReveal() {
      var revealEls = document.querySelectorAll('.bf-reveal, .bf-reveal-stagger, .bf-story-reveal');

      if (!('IntersectionObserver' in window)) {
        revealEls.forEach(function (el) {
          el.classList.add('bf-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries, revealObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bf-visible');
          revealObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -50px 0px'
      });

      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBaseformReveal, { once: true });
    } else {
      initBaseformReveal();
    }
  })();
(function () {
    if (window.__bfHeroVideoLoaded) return;
    window.__bfHeroVideoLoaded = true;

    var viewportQuery = window.matchMedia('(max-width: 749px)');

    function addMediaListener(query, handler) {
      if (typeof query.addEventListener === 'function') {
        query.addEventListener('change', handler);
      } else {
        query.addListener(handler);
      }
    }

    function getVideo() {
      return document.querySelector('.bf-hero-video[data-desktop-src][data-mobile-src]');
    }

    function syncPlayback(video) {
      var playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(function () {
          if (!video.paused && video.readyState >= 2) {
            video.classList.add('is-playing');
          }
        }).catch(function () {
          video.classList.remove('is-playing');
        });
      } else if (!video.paused && video.readyState >= 2) {
        video.classList.add('is-playing');
      }
    }

    function bindVideo(video) {
      if (video.dataset.bfVideoBound === 'true') return;

      video.dataset.bfVideoBound = 'true';
      video.muted = true;
      video.playsInline = true;

      video.addEventListener('loadeddata', function () {
        video.classList.remove('is-switching');
        syncPlayback(video);
      });

      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });

      video.addEventListener('timeupdate', function () {
        if (!video.paused && video.readyState >= 2) {
          video.classList.add('is-playing');
        }
      });

      video.addEventListener('pause', function () {
        video.classList.remove('is-playing');
      });

      video.addEventListener('error', function () {
        video.classList.remove('is-switching', 'is-playing');
      });
    }

    function syncSource() {
      var video = getVideo();

      if (!video) return;

      bindVideo(video);

      var nextSource = viewportQuery.matches
        ? video.dataset.mobileSrc
        : video.dataset.desktopSrc;

      if (!nextSource) return;

      var activeSource = video.dataset.activeSrc || video.currentSrc;

      if (!activeSource) {
        video.dataset.activeSrc = nextSource;
        syncPlayback(video);
        return;
      }

      if (activeSource !== nextSource) {
        video.classList.add('is-switching');
        video.pause();
        video.src = nextSource;
        video.dataset.activeSrc = nextSource;
        video.load();
        return;
      }

      video.dataset.activeSrc = nextSource;

      if (video.readyState >= 2) {
        video.classList.remove('is-switching');
      }

      syncPlayback(video);
    }

    addMediaListener(viewportQuery, syncSource);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncSource, { once: true });
    } else {
      syncSource();
    }

    document.addEventListener('shopify:section:load', syncSource);
  })();
